import { render, staticRenderFns } from "./ModalAlertDelete.vue?vue&type=template&id=39ca1bbb&scoped=true&"
import script from "./ModalAlertDelete.vue?vue&type=script&lang=js&"
export * from "./ModalAlertDelete.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlertDelete.vue?vue&type=style&index=0&id=39ca1bbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ca1bbb",
  null
  
)

export default component.exports